import { render, staticRenderFns } from "./FuncionalidadeCustomizadaChatBotComponent.vue?vue&type=template&id=4a411c6a&scoped=true"
import script from "./FuncionalidadeCustomizadaChatBotComponent.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizadaChatBotComponent.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeCustomizadaChatBotComponent.vue?vue&type=style&index=0&id=4a411c6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a411c6a",
  null
  
)

export default component.exports